import { UserRound } from 'lucide-react';

export function ArtistImageNotFound() {
  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
      <UserRound size={24} />
    </div>
  );
}
